import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getCleaningscheduleData(context) {
      const response = await Vue.axios.get(`${URL_API}cleaningschedule`);
      let data = response["data"];
      context.commit("updateCleaningscheduleData", data);
    },
    async createCleaningscheduleData(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}cleaningschedule/store`, body, config);
      context.dispatch("getCleaningscheduleData");
    },
    async pushCleaningscheduleData(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}cleaningschedule/update`, body, config);
      context.dispatch("getCleaningscheduleData");
    },
    async destroyCleaningscheduleData(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}cleaningschedule/destroy`, body, config);
      context.dispatch("getCleaningscheduleData");
    }
  },
  mutations: {
    updateCleaningscheduleData(state, cleaningscheduleData) {
      state.cleaningscheduleData = cleaningscheduleData;
    }
  },
  state: {
    cleaningscheduleData: []
  },
  getters: {
    allCleaningscheduleData(state) {
      return state.cleaningscheduleData;
    }
  }
};